import React from 'react';
import { MessageSquare, PhoneCall, Send } from 'lucide-react';

/**
 * Mini previews of Chatbot + Outbound (Phone) for the dashboard tutorial Test step.
 */
export default function TutorialTestChannelsMockup() {
  return (
    <div className="mt-5" aria-hidden>
      <p className="text-sm font-semibold text-[#459EA3] uppercase tracking-wide mb-2">How to test</p>
      <p className="text-sm text-gray-500 mb-4 max-w-4xl">
        Use <strong className="text-gray-700">Chatbot</strong> for a quick text conversation. Use{' '}
        <strong className="text-gray-700">Outbound</strong> to place a real test call from a configured line to your phone.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6 md:gap-8 md:items-stretch min-h-[min(52vh,420px)]">
        {/* Chatbot */}
        <div className="rounded-2xl border border-gray-200 bg-white shadow-md overflow-hidden flex flex-col min-h-[min(48vh,380px)] md:min-h-[min(52vh,440px)]">
          <div className="shrink-0 px-4 py-3 bg-gradient-to-r from-[#459EA3] to-[#27AAE1] text-white flex items-center gap-2">
            <MessageSquare className="w-5 h-5 sm:w-6 sm:h-6 shrink-0 opacity-95" />
            <span className="text-sm sm:text-base font-semibold truncate">Chatbot</span>
          </div>
          <div className="flex-1 min-h-[200px] bg-[#f5f7fa] p-4 sm:p-5 space-y-3 flex flex-col justify-center">
            <div className="flex justify-end">
              <div className="max-w-[92%] rounded-xl bg-[#459EA3] text-white px-3 py-2 text-xs sm:text-sm leading-snug shadow-sm">
                What hours are you open?
              </div>
            </div>
            <div className="flex justify-start">
              <div className="max-w-[92%] rounded-xl bg-white border border-gray-200 px-3 py-2 text-xs sm:text-sm text-gray-700 leading-snug shadow-sm">
                We&apos;re open weekdays 9–5…
              </div>
            </div>
            <p className="text-xs text-gray-400 text-center pt-2">Type messages here to test the script</p>
          </div>
          <div className="shrink-0 p-3 sm:p-4 border-t border-gray-200/80 flex gap-2 bg-white">
            <div className="flex-1 h-10 sm:h-11 rounded-xl border border-gray-200 bg-gray-50 text-sm px-3 flex items-center text-gray-400">
              Message…
            </div>
            <span className="inline-flex h-10 w-10 sm:h-11 sm:w-11 items-center justify-center rounded-xl bg-[#459EA3] text-white shrink-0 shadow-sm">
              <Send className="w-4 h-4 sm:w-5 sm:h-5" />
            </span>
          </div>
          <p className="text-xs sm:text-sm text-gray-500 px-4 pb-3 sm:px-5 sm:pb-4 bg-white leading-snug">
            End session when done — your chat can be saved to Logs.
          </p>
        </div>

        {/* Outbound */}
        <div className="rounded-2xl border border-gray-200 bg-white shadow-md overflow-hidden flex flex-col min-h-[min(48vh,380px)] md:min-h-[min(52vh,440px)]">
          <div className="shrink-0 px-4 py-3 bg-gray-100 border-b border-gray-200/80 flex items-center gap-2 text-gray-800">
            <PhoneCall className="w-5 h-5 sm:w-6 sm:h-6 text-[#459EA3] shrink-0" />
            <span className="text-sm sm:text-base font-semibold">Outbound</span>
          </div>
          <div className="flex-1 p-4 sm:p-5 space-y-4 bg-[#fafafa] flex flex-col justify-center min-h-0">
            <div>
              <label className="block text-[10px] sm:text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">
                Calling from
              </label>
              <div className="h-10 sm:h-11 rounded-xl border border-gray-300 bg-white shadow-sm flex items-center px-3 text-xs sm:text-sm text-gray-500">
                +1 … your registered line
              </div>
            </div>
            <div>
              <label className="block text-[10px] sm:text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">
                Call this number
              </label>
              <div className="h-10 sm:h-11 rounded-xl border border-dashed border-[#459EA3]/40 bg-[#f0fffd] flex items-center px-3 text-xs sm:text-sm text-gray-600">
                +1 (555) 000-0000
              </div>
            </div>
            <button
              type="button"
              tabIndex={-1}
              className="w-full py-3 sm:py-3.5 rounded-xl bg-[#459EA3] text-white text-sm font-semibold shadow-md opacity-90 pointer-events-none"
            >
              Place test call
            </button>
            <p className="text-xs text-gray-500 leading-relaxed">
              Pick a number that already has your outbound script (and KB if you use it). Listen for greeting, latency, and hangup.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
